/**
 * Small helper that builds a URL with audit-context query params appended.
 * Used to hand off audit context to the Dubsado scheduler URL and form iframe.
 */
export function buildAuditParams({ result, lead }) {
  if (!result || !lead) return {};
  const offer = result.prescription?.offer;
  return {
    audit_id: result.id || "",
    primary_gap: result.diagnosis?.primary_gap || "",
    secondary_gap: result.diagnosis?.secondary_gap || "",
    prescription: offer?.name || "",
    name: lead.name || "",
    email: lead.email || "",
    business: lead.business_name || "",
    website: lead.website_url || "",
    audit_url: result.id ? `${window.location.origin}/audit/${result.id}` : "",
  };
}

export function appendParams(baseUrl, params) {
  if (!baseUrl) return baseUrl;
  try {
    const u = new URL(baseUrl);
    Object.entries(params).forEach(([k, v]) => {
      if (v) u.searchParams.set(k, String(v));
    });
    return u.toString();
  } catch {
    return baseUrl;
  }
}
